import React from 'react';

const CaretRight: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 14" fill="none" {...props}>
    <path
      fill="currentColor"
      d="M8.73 6.984a1.342 1.342 0 01-.455 1.008L1.77 13.715a1.077 1.077 0 01-1.423-1.617l5.689-5.005a.146.146 0 000-.219L.347 1.87A1.077 1.077 0 011.77.252l6.503 5.721a1.348 1.348 0 01.457 1.01z"
    ></path>
  </svg>
);

export default CaretRight;
